<template>
    <div class="mb-4">
        <confirm-box ref="error" :noConfirm="true"></confirm-box>
        <confirm-box ref="confirm" ></confirm-box>
        <h3 v-if="id == -1" class="h3 text-primary">New Standard</h3>
        <h3 v-else class="h3 text-primary">Editing Standard ({{ id }})</h3>
        <div class="row mb-3">
            <div class="col-12 mb-2 col-md-6 mb-md-0 col-lg-4">
                <div class="">
                    <label class="form-label" for="code-input">Code</label>
                    <input v-model="code" id="code-input" class="form-control" placeholder="Code" aria-label="Code" aria-describedby="code-label" />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <div class="">
                    <label class="form-label" for="subcode-input">Subcode</label>
                    <input v-model="subcode" id="subcode-input" class="form-control" placeholder="Subcode" aria-label="Subcode" aria-describedby="subcode-label" />
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="">
                <label class="form-label" for="area-input">Area</label>
                <select v-model="area_id" id="area-input" class="form-select" @change="getStrands" aria-label="Area" aria-describedby="area-label">
                    <option v-for="ar in areas" :value="ar.id">{{ ar.name }} ({{ ar.state }}-{{ ar.year }})</option>
                </select>
            </div>
        </div>
        <div class="mb-3">
            <div>
                <label class="form-label" for="grade-level-input">Grade Level</label>
                <grade-level-element v-model="grade_level" id="grade-level-input" @input="getStrands" aria-label="Grade Level" aria-describedby="grade-level-label"></grade-level-element>
            </div>
        </div>

        <div class="row mb-3">
            <div class="">
                <label class="form-label" for="strand-input">Strand</label>
                <input v-model="strand" id="strand-input" list="strand-options" class="form-control" 
                    placeholder="Strand" aria-label="Strand" aria-describedby="strand-label" :readonly="strandAllow">
                <datalist id="strand-options">
                    <option v-for="st in strands" :value="st.strand"></option>
                </datalist>
            </div>
        </div>

        <div class="mb-3">
            <div>
                <label class="form-label" for="content-input">Content</label>
                <textarea v-model="content" id="content-input" class="form-control" aria-label="Content" aria-describedby="content-label"></textarea>
            </div>
        </div>

        <div class="mb-3">
            <div>
                <label class="form-label" for="notes-input">Notes</label>
                <textarea v-model="notes" id="notes-input" class="form-control" aria-label="Notes" aria-describedby="notes-label"></textarea>
            </div>
        </div>

        <cancel-submit-button
            @cancel="cancel()"
            @submit="save()"
        >
            <div class="flex-grow-1">
                <button v-if="id >= 0" class="btn btn-secondary" @click="askDelete"><i class="fas fa-trash-alt me-2"></i>Delete</button>
            </div>
        </cancel-submit-button>
    </div>
</template>

<script>
import GradeLevelElement from './GradeLevelElement.vue';
import ConfirmBox from './ConfirmBox';
import CancelSubmitButton from './CancelSubmitButton.vue';
import axios from 'axios';

export default {
    components: { GradeLevelElement, ConfirmBox, CancelSubmitButton },

    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return {};
            }
        },

        areas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            id: this.value.id ?? -1,
            area_id: this.value.area_id ?? -1,
            code: this.value.code ?? '',
            subcode: this.value.subcode ?? '',
            grade_level: this.value.grade_level ?? '',
            strand: this.value.strand ?? '',
            content: this.value.content ?? '',
            notes: this.value.notes ?? '',

            strands: [],
            strandTimeout: null,
        }
    },

    computed: {
        strandAllow: function() {
            return false;
            //return this.area_id < 0 || this.grade_level == '';
        }
    },

    mounted() {
        this.getStrands();
    },

    methods: {
        cancel: function() {
            this.$parent.editing = -1;
        },

        getStrands: function() {
            clearTimeout(this.strandTimeout);
            this.strandTimeout = setTimeout(() => {
                this.$parent.isLoading = true;
                const data = {
                    headers: {},
                    params: {
                        grade_levels: this.grade_level ?? '',
                        areas: [this.area_id]
                    }
                };

                axios
                    .get('/api/strands', data)
                    .then(response => {
                        console.debug(response.data);
                        this.strands = response.data;
                    })
                    .catch(error => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });
            }, 1000);
        },

        clear: function() {
            this.id = -1;
            this.area_id = -1;
            this.code = '';
            this.subcode = '';
            this.grade_level = '';
            this.strand = '';
            this.content = '';
            this.notes = '';
            this.strands = [];
        },

        save: function() {
            this.$parent.isLoading = true;

            const data = {
                area_id: this.area_id,
                code: this.code,
                subcode: this.subcode,
                grade_level: this.grade_level,
                strand: this.strand,
                content: this.content,
                notes: this.notes,
            };

            console.log(this.id);

            if (this.id == -1) {
                this.create(data);
            } else {
                this.update(data);
            }
        },

        update: function(data) {
            axios
                .patch(`/api/admin/standards/${this.id}`, data)
                .then((response) => {
                    this.$emit('input', response.data);
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'Updating Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                    } else {
                        console.error(error);
                        console.error(error.response);
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },

        create: function(data) {
            console.log('POST');
            axios
                .post('/api/admin/standards', data)
                .then((response) => {
                    this.clear();
                    this.$emit('input', response.data);
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'Updating Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                    } else {
                        console.error(error);
                        console.error(error.response);
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });

        },

        askDelete: function() {
            this.$refs.confirm.show({
                title: 'Delete Standard',
                content: `Are you sure you would like to delete standard ${this.code}?`,
                callback: () => { this.remove() }
            });
        },

        remove: function() {
            this.$parent.isLoading = true;
            axios
                .delete(`/api/admin/standards/${this.id}`)
                .then(response => {
                    this.clear();
                    this.$emit('delete');
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },
    }

}
</script>